// removed by extract-text-webpack-plugin
module.exports = {"Table":"CtorL","TableSimple":"ipoXK"};


//////////////////
// WEBPACK FOOTER
// ./visualizations/components/Table.css
// module id = 463
// module chunks = 3 4 5